var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dictionary',{attrs:{"displayCategory":_vm.displayCategory,"dictionary":_vm.dictionary}})}
var staticRenderFns = []

export { render, staticRenderFns }